<div [formGroup]="form" class="d-flex">
  <div class="d-flex flex-column">
    @switch (currentFormStep()) {
        @case(NvbLeveransvirkeFormStep.MisstankeOmHogaNaturvarden){
        <rask-radiobutton-group
          label="Finns misstanke om att virket kommer från ett område med höga naturvärden?"
          [verticalLayout]="true"
          formControlName="misstankeOmHogaNaturvarden"
            [buttons]="[{ key: true, value: 'Ja' }, { key: false, value: 'Nej' }]">
        </rask-radiobutton-group>
      }
        @case(NvbLeveransvirkeFormStep.AtgardsTyp){
        <rask-radiobutton-group
            label="Vilken åtgärdstyp kommer träråvaran från?"
          [verticalLayout]="true"
          formControlName="atgardsTyp"
            [buttons]="[{ key: 'Föryngringsavverkning', value: 'Föryngringsavverkning, Gallring i skog med ålder över LSÅ, Avverkning för annan markanvändning, (T ex Väglinjeavverkning, Kraftledning, Solpark)' }, { key: 'Övrig avverkning', value: 'Övrig avverkning' }]">
        </rask-radiobutton-group>
      }
        @case(NvbLeveransvirkeFormStep.FormOrFileNvb){
        <rask-radiobutton-group
          label="Hur ska naturvärdesbedömningen genomföras?"
          [verticalLayout]="true"
          formControlName="formOrFileNvb"
            [buttons]="[{ key: 'Formulär', value: 'Formulär' }, { key: 'Fil', value: 'Fil' }]">
        </rask-radiobutton-group>
      }
        @case(NvbLeveransvirkeFormStep.FormOrFileRiskbedomning){
        <rask-radiobutton-group
          label="Hur ska riskbedömningen genomföras?"
          [verticalLayout]="true"
          formControlName="formOrFileRiskbedomning"
          [buttons]="[
            { key: 'Riskbedömning', value: 'Formulär' },
            { key: 'Riskbedömning-Fil', value: 'Fil' },
          ]"
        >
        </rask-radiobutton-group>
      }
    }
        @if(currentFormStep() !== NvbLeveransvirkeFormStep.MisstankeOmHogaNaturvarden){
      <div class="mt-2">
        <rask-button color="secondary" negative (click)="goBack()">
          Avbryt
        </rask-button>
      </div>
    }

  </div>
  <rask-button
    class="ms-auto"
    color="secondary"
    (click)="continue()"
        [disabled]="!isValid() || isReadOnly() || naturvardesbedomning()?.utfordDatum">
    Fortsätt
  </rask-button>

</div>